export function mockOpenAISummary() {
  return `Alex Ramirez is progressing well toward his goals, but lacks insurance and estate planning. Recommend establishing term life insurance, boosting emergency fund, and clarifying investment strategy for homeownership.`;
}

export function mockGenerateInsights() {
  return [
    {
      title: "Nice Job Saving!",
      emoji: "💰",
      text: "You're contributing $600/month to savings. Keep it up to reach your $25K emergency fund goal in ~3 years."
    },
    {
      title: "Dining Overspend",
      emoji: "🍔",
      text: "Dining out is up 28% this month. Shifting just $100/month could speed up your emergency savings."
    },
    {
      title: "Travel Trend",
      emoji: "✈️",
      text: "You've spent $300 on travel this month. Want to move this into a dedicated sinking fund?"
    }
  ];
} 